"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var compact = _a.compact;
            return ({
                position: 'relative',
                padding: compact ? 0 : theme.spacing(2),
                // NOTE: height and width set to 100% using box props so they can be overridden directly
            });
        },
        content: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
            color: '#000',
        },
        button: function (_a) {
            var compact = _a.compact;
            return ({
                padding: compact ? 0 : undefined,
                minWidth: compact ? 'auto' : undefined,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                borderRadius: 0,
                '& > .MuiButton-label': {
                    display: 'block',
                    height: '100%',
                    width: '100%',
                },
            });
        },
        remove: {
            position: 'absolute',
            cursor: 'pointer',
            right: theme.spacing(0.5),
            top: theme.spacing(0.5),
            backgroundColor: 'rgba(255,255,255, 0.5)',
            zIndex: 3,
            '&:hover': {
                backgroundColor: 'rgba(255,255,255, 1)',
            },
        },
        name: {
            textAlign: 'center',
        },
    });
});
